import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';

const ComercialType = ({ dropDownData, handleValue }) => {
  const inputData = {
    commercial_type_id: '',
    description: '',
    cost_per_slot: '',
    location: '',
    no_of_slot: '',
  };

  const [formData, setData] = useState(inputData);
  const handleData = () => {
    if (formData.commercial_type_id !== '') {
      handleValue({
        commercial: [{ ...formData }],
      });
    } else {
      handleValue(null);
    }
  };
  useEffect(() => {
    handleData();
  }, [formData]);
  return (
    <FormSection title={localization.commercialType}>
      <DropDownInput
        label={localization.commercialType}
        data={dropDownData.commercialTypes}
        required
        errorMsg={localization.requiredcommercialType}
        getIdValue={(value) =>
          setData({ ...formData, commercial_type_id: value.id })
        }
        label={localization.commercialType}
      />
      {formData.commercial_type_id ? (
        <Fragment>
          <ConstantInput
            required
            isStarRequired={true}
            type="text"
            maxLength={3}
            regex={Regex.number.test(formData.no_of_slot)}
            errorMsg={
              formData.no_of_slot
                ? localization.numericError
                : localization.requiredSlot
            }
            label={localization.noOfSlots}
            handleChange={(value) =>
              setData({ ...formData, no_of_slot: value })
            }
          />
          <ConstantInput
            required
            isStarRequired={true}
            errorMsg={localization.requiredlocation}
            label={localization.location}
            regex={Regex.text.test(formData.location)}
            handleChange={(value) => setData({ ...formData, location: value })}
          />
          <ConstantInput
            required
            isStarRequired={true}
            type="text"
            className="indianrupee"
            isPrefix
            prefixText={'₹'}
            regex={Regex.twodecimal.test(formData.cost_per_slot)}
            errorMsg={
              formData.cost_per_slot
                ? localization.requiredDecimal
                : localization.requiredcost
            }
            label={localization.cost}
            handleChange={(value) =>
              setData({ ...formData, cost_per_slot: value })
            }
          />
        </Fragment>
      ) : null}
    </FormSection>
  );
};

ComercialType.propTypes = {};

export default ComercialType;
